// Derivations of display identity (initials, name) from a user object. Shared by
// the app shell account UI and the account settings form.

/**
 * Two-letter uppercase initials from first + last name, falling back to the
 * first two characters of the email.
 * @param {{firstName?: string, lastName?: string, email?: string}} [user]
 * @returns {string} Initials, or '' when no user is given.
 */
export function deriveUserInitials(user) {
  if (!user) return '';
  const first = (user.firstName ?? '').charAt(0);
  const last = (user.lastName ?? '').charAt(0);
  const initials = `${first}${last}`.toUpperCase();
  return initials || (user.email ?? '').slice(0, 2).toUpperCase();
}

/**
 * Full name ("First Last"), falling back to the email when no name is on file.
 * @param {{firstName?: string, lastName?: string, email?: string}} [user]
 * @returns {string} The full name, or '' when no user is given.
 */
export function deriveFullUserName(user) {
  if (!user) return '';
  const full = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  return full || user.email || '';
}
